import { render, staticRenderFns } from "./IconExit.vue?vue&type=template&id=20533f21&"
import script from "./IconExit.vue?vue&type=script&lang=ts&"
export * from "./IconExit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports